import en from "./en.json"
import zh from "./zh-CN.json"
import tw from "./zh-TW.json"
import VueI18n from "vue-i18n"
import Cookie from "js-cookie"
import Vue from "vue"

Vue.use(VueI18n)

const DEFAULT_LANG = "zh-CN"
const LOCALE_KEY = "_t_language"

const locales = {
  "zh-CN": zh,
  "zh-TW": tw,
  en,
}

export type AllLanguages = keyof typeof locales
interface Language {
  readonly name: string
  readonly value: AllLanguages
}
export const LANGUAGE_LIST: Language[] = [
  {
    name: "中文简体",
    value: "zh-CN",
  },
  {
    name: "中文繁體",
    value: "zh-TW",
  },
  {
    name: "English",
    value: "en",
  },
]

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: "zh-CN",
})

export const setLang = (lang: AllLanguages) => {
  const hosts = window.location.host?.split('.')
  const domain = `.${hosts?.length > 2 ? hosts.slice(-3).join('.') : hosts?.join('.')}`
  Cookie.set(LOCALE_KEY, lang, { domain, expires: 365 * 10 })

  const htmlDom = document.querySelector("html") as Element
  htmlDom.setAttribute("lang", lang)

  i18n.locale = lang
}

const setup = (lang?: AllLanguages) => {
  if (lang === undefined) {
    lang = Cookie.get(LOCALE_KEY) as AllLanguages
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  setLang(lang)
}

setup()

export default i18n
